import { Component } from '@angular/core';
import { CreateRejectionReason } from '../../../../components/admin-dashboard-component/rejection-reasons/create-rejection-reason/create-rejection-reason';
@Component({
  selector: 'app-create-new-reason',
  imports: [CreateRejectionReason],
  templateUrl: './create-new-reason.html',
  styleUrl: './create-new-reason.scss',
})
export class CreateNewReason {}
